import { SVGProps } from 'react'

export const NeDescSvg = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g fill='none' fillRule='evenodd'>
        <rect
          height='84'
          rx='20'
          stroke='currentColor'
          strokeWidth='20'
          width='180'
          x='38'
          y='38'
        />
        <rect
          fill='currentColor'
          height='20'
          rx='10'
          width='200'
          x='28'
          y='158'
        />
        <rect
          fill='currentColor'
          height='20'
          rx='10'
          width='120'
          x='28'
          y='208'
        />
      </g>
    </svg>
  )
}
